import { TableScreen } from "@/feature/table/TableScreen"
import { TopScreen } from "@/feature/table/TopScreen"
import { useRoutes } from "react-router-dom"

export const AppRoutes = () => {
	const element = useRoutes([
		{ path: "/tables", element: <TableScreen /> },
		{ path: "*", element: <TopScreen /> },
	])
	return <>{element}</>
}
